export const DASHBOARDS_2_1_URL = 'dashboards-2-1'
export const DASHBOARD_URL = DASHBOARDS_2_1_URL
export const DASHBOARDS_2_1_DETAIL_URL = 'dashboards-2-1-detail'
export const DASHBOARDS_2_1_TRANSACTION_PATH = `/project/:id/${DASHBOARDS_2_1_URL}`
export const DASHBOARDS_2_1_DETAIL_TRANSACTION_PATH = `/project/:id/${DASHBOARDS_2_1_URL}/:customDashboardId`

export const dashboards21DetailPath = (
  projectId: string,
  dashboardId: string,
): string => `/project/${projectId}/${DASHBOARDS_2_1_URL}/${dashboardId}`

export const dashboards21ListPath = (projectId: string): string =>
  `/project/${projectId}/${DASHBOARDS_2_1_URL}`

export const DASHBOARDS_2_1_TEMPLATE_SETUP_TRANSACTION_PATH = `/project/:id/${DASHBOARDS_2_1_URL}/templates/:templateId/setup`

export const dashboardTemplateSetupPath = (
  projectId: string,
  templateId: string,
): string =>
  `/project/${projectId}/${DASHBOARDS_2_1_URL}/templates/${templateId}/setup`

export const SHARE_DASHBOARD_V2_1 = `/project/:id/${DASHBOARDS_2_1_URL}/:dashboardId/shared/:token`
